import React from 'react';
import styled from 'styled-components';
import { useDispatch } from 'react-redux';
import { tabsOpened } from 'store/actions/tabs';
import { IRefIds } from 'constants/refs';
import { ICourseUsage } from 'types/translationBank';

interface IProps {
  usages: ICourseUsage[];
}

const CourseUsages: React.FC<IProps> = ({ usages }) => {
  const dispatch = useDispatch();

  const handleClick = (courseId: number, translationIds: number[]) => {
    dispatch(
      tabsOpened({
        refId: IRefIds.sourceAdaptation,
        courseId,
        search: translationIds.join(','),
      }),
    );
  };

  if (usages.length === 0) {
    return null;
  }

  return (
    <Container>
      <Title>Course usages</Title>
      <List>
        {usages.map((usage) => (
          <Row key={usage.courseId}>
            <span>{usage.courseName}:</span>
            <CountLink onClick={() => handleClick(usage.courseId, usage.translationIds)}>{usage.count}</CountLink>
          </Row>
        ))}
      </List>
    </Container>
  );
};

export default CourseUsages;

const Container = styled.div`
  padding: 8px 12px;
  border-top: 1px solid #e0e0e0;
`;

const Title = styled.div`
  font-weight: 600;
  margin-bottom: 4px;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 4px;
`;

const CountLink = styled.span`
  color: #1976d2;
  cursor: pointer;
  text-decoration: underline;
  &:hover {
    color: #1565c0;
  }
`;
